import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Meet Merabuddy</h1>
            <h2>Your Smart Reminder Assistant</h2>
            <p>
              Never forget anything important again. Merabuddy intelligently
              manages your tasks, appointments and reminders with AI-powered
              scheduling that adapts to your lifestyle.
            </p>
            <div className="hero-actions">
              <a href="#cta" className="btn btn-primary">
                Start Your Journey
              </a>
              <a href="#features" className="btn btn-secondary">
                Learn More
              </a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="card-header">
                <div className="card-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="card-content">
                <div className="chat-bubble user">
                  <p>Remind me to call mom at 3 PM</p>
                </div>
                <div className="chat-bubble ai">
                  <p>
                    Perfect! I'll remind you to call mom at 3 PM today. I've
                    also noticed you usually call her on Sundays - should I set
                    up a weekly reminder?
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
